import { Breadcrumb, Button, Input, Select } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
// import "./OrderApproval.css";
import { Checkbox } from "antd";
import { time } from "react-i18next/icu.macro";

const { TextArea } = Input;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};

const columns = [
  //   {
  //     title: "Sr. No.",
  //     dataIndex: "SRNO",
  //   },
  //   {
  //     title: "City",
  //     dataIndex: "CITY",
  //   },
  //   {
  //     title: "Site Name",
  //     dataIndex: "SITENAME",
  //   },
  //   {
  //     title: "Items",
  //     dataIndex: "ITEMS",
  //     width: "10%",
  //   },
  //   {
  //     title: "Quantity",
  //     dataIndex: "QUANTITY",
  //   },
  //   {
  //     title: "UOM",
  //     dataIndex: "UOM",
  //   },
  //   {
  //     title: "Unit Rate",
  //     dataIndex: "UNITRATE",
  //   },
  //   {
  //     title: "Total Amount",
  //     dataIndex: "TOTALAMOUNT",
  //   },
  //   {
  //     title: "Unit Rate",
  //     dataIndex: "UNITRATE",
  //   },
  //   {
  //     title: "Total Amount",
  //     dataIndex: "TOTALAMOUNT",
  //   },

  //   {
  //     title: "Unit Rate",
  //     dataIndex: "UNITRATE",
  //   },
  //   {
  //     title: "Total Amount",
  //     dataIndex: "TOTALAMOUNT",
  //   },
  // ];

  {
    title: "Sr. No.",
    dataIndex: "SRNO",
  },
  {
    title: "City",
    dataIndex: "CITY",
  },
  {
    title: "Site Name",
    dataIndex: "SITENAME",
  },
  {
    title: "Items",
    dataIndex: "ITEMS",
    // width: "10%",
  },
  {
    title: "Quantity",
    dataIndex: "QUANTITY",
  },
  {
    title: "UOM",
    dataIndex: "UOM",
  },

  {
    title: "SANGHI INDUSTRIES LTD THROUGH ACC",
    children: [
      {
        title: "Unit Rate",
        dataIndex: "UNITRATE",
      },
      {
        title: "Total Amount",
        dataIndex: "TOTALAMOUNT",
      },
    ],
  },

  {
    title: "SHREE DIGVIJAY CEMENT CO. LTD",
    children: [
      {
        title: "Unit Rate",
        dataIndex: "UNITRATE",
      },
      {
        title: "Total Amount",
        dataIndex: "TOTALAMOUNT",
      },
    ],
  },
  {
    title: "Vendor 3",
    children: [
      {
        title: "Unit Rate",
        dataIndex: "UNITRATE",
      },
      {
        title: "Total Amount",
        dataIndex: "TOTALAMOUNT",
      },
    ],
  },
];

const data = [
  {
    key: "1",
    SRNO: <Input placeholder="1" disabled />,
    CITY: <Input placeholder="Ahmedabad" disabled />,
    SITENAME: <Input placeholder="Site 1" disabled />,
    ITEMS: <Input placeholder="OPC 43" disabled />,
    QUANTITY: <Input placeholder="20" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="100" disabled />,
    TOTALAMOUNT: <Input placeholder="2000" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="OPC 53" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="50" disabled />,
    TOTALAMOUNT: <Input placeholder="500" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="PPC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="30" disabled />,
    TOTALAMOUNT: <Input placeholder="300" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="RMC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="20" disabled />,
    TOTALAMOUNT: <Input placeholder="200" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "Sub-Total",
    ITEMS: "",
    QUANTITY: "",
    UOM: "",
    UNITRATE: (
      <div>
        <Checkbox onChange={onChange}>Check</Checkbox>
        <Select
          mode="multiple"
          style={{ width: "100%", marginTop: 8 }}
          placeholder="Select Reason"
          onChange={handleChange}
        >
          <Select.Option value="option1">Option 1</Select.Option>
          <Select.Option value="option2">Option 2</Select.Option>
        </Select>
      </div>
    ),
    TOTALAMOUNT: <Input placeholder="5500" />,
  },

  // Site 2
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: <Input placeholder="Site 2" disabled />,
    ITEMS: <Input placeholder="OPC 43" disabled />,
    QUANTITY: <Input placeholder="20" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="100" disabled />,
    TOTALAMOUNT: <Input placeholder="2000" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="OPC 53" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="50" disabled />,
    TOTALAMOUNT: <Input placeholder="500" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="PPC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="30" disabled />,
    TOTALAMOUNT: <Input placeholder="300" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="RMC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="20" disabled />,
    TOTALAMOUNT: <Input placeholder="200" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "Sub-Total",
    ITEMS: "",
    QUANTITY: "",
    UOM: "",
    UNITRATE: (
      <div>
        <Checkbox onChange={onChange}>Check</Checkbox>
        <Select
          mode="multiple"
          style={{ width: "100%", marginTop: 8 }}
          placeholder="Select Reason"
          onChange={handleChange}
        >
          <Select.Option value="option1">Option 1</Select.Option>
          <Select.Option value="option2">Option 2</Select.Option>
        </Select>
      </div>
    ),
    TOTALAMOUNT: <Input placeholder="5500" />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "City Sub-Total",
    ITEMS: "",
    QUANTITY: "",
    UOM: "",
    UNITRATE: "",
    TOTALAMOUNT: <Input placeholder="110000" />,
  },

  //SRNO 2
  {
    key: "1",
    SRNO: <Input placeholder="2" disabled />,
    CITY: <Input placeholder="Rajkot" disabled />,
    SITENAME: <Input placeholder="Site 1" disabled />,
    ITEMS: <Input placeholder="OPC 43" disabled />,
    QUANTITY: <Input placeholder="20" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="100" disabled />,
    TOTALAMOUNT: <Input placeholder="2000" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="OPC 53" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="50" disabled />,
    TOTALAMOUNT: <Input placeholder="500" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="PPC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="30" disabled />,
    TOTALAMOUNT: <Input placeholder="300" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="RMC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="20" disabled />,
    TOTALAMOUNT: <Input placeholder="200" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "Sub-Total",
    ITEMS: "",
    QUANTITY: "",
    UOM: "",
    UNITRATE: (
      <div>
        <Checkbox onChange={onChange}>Check</Checkbox>
        <Select
          mode="multiple"
          style={{ width: "100%", marginTop: 8 }}
          placeholder="Select Reason"
          onChange={handleChange}
        >
          <Select.Option value="option1">Option 1</Select.Option>
          <Select.Option value="option2">Option 2</Select.Option>
        </Select>
      </div>
    ),
    TOTALAMOUNT: <Input placeholder="5500" />,
  },

  // Site 2
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: <Input placeholder="Site 2" disabled />,
    ITEMS: <Input placeholder="OPC 43" disabled />,
    QUANTITY: <Input placeholder="20" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="100" disabled />,
    TOTALAMOUNT: <Input placeholder="2000" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="OPC 53" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="50" disabled />,
    TOTALAMOUNT: <Input placeholder="500" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="PPC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="30" disabled />,
    TOTALAMOUNT: <Input placeholder="300" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "",
    ITEMS: <Input placeholder="RMC" disabled />,
    QUANTITY: <Input placeholder="10" disabled />,
    UOM: <Input placeholder="MT" disabled />,
    UNITRATE: <Input placeholder="20" disabled />,
    TOTALAMOUNT: <Input placeholder="200" disabled />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "Sub-Total",
    ITEMS: "",
    QUANTITY: "",
    UOM: "",
    UNITRATE: (
      <div>
        <Checkbox onChange={onChange}>Check</Checkbox>
        <Select
          mode="multiple"
          style={{ width: "100%", marginTop: 8 }}
          placeholder="Select Reason"
          onChange={handleChange}
        >
          <Select.Option value="option1">Option 1</Select.Option>
          <Select.Option value="option2">Option 2</Select.Option>
        </Select>
      </div>
    ),
    TOTALAMOUNT: <Input placeholder="5500" />,
  },
  {
    key: "1",
    SRNO: "",
    CITY: "",
    SITENAME: "City Sub-Total",
    ITEMS: "",
    QUANTITY: "",
    UOM: "",
    UNITRATE: "",
    TOTALAMOUNT: <Input placeholder="110000" />,
  },
];

export default function OrderApproval() {
  const [size, setSize] = useState("large"); // default is 'middle'

  return (
    <>
      <div className="main-container">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              <h3>Summery Of Price Comparative Statement</h3>

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  Summery Of Price Comparative Statement
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
        </div>

        <div className="RFQ_Number_Container">
          <div className="RFQ_Number">
            <span>RFQ Number</span>
            <div className="RFQ_Text">
              <span>RFQ - C01-001</span>
            </div>
          </div>
          <div className="">
            <Button type="primary" size={size}>
              Order Summary
            </Button>
          </div>
        </div>
        {/* <div className="order_container">
          <div>SANGHI INDUSTRIES LTD THROUGH ACC</div>
          <div>SHREE DIGVIJAY CEMENT CO. LTD</div>
          <div>Vendor 3</div>
        </div> */}
        <Table
          columns={columns}
          dataSource={data}
          size="large"
          pagination={false}
          bordered
          style={{ border: "1px solid #e8e8e8" }}
        />
      </div>
      <div className="total-amt">
        <div>
          <span> Total Amount :</span>
          <Button type="primary" size={size}>
            Preview and Send for Approval
          </Button>
        </div>
      </div>
    </>
  );
}
